export const GRAPH_TAB = "graph";
export const MATCHED_TAB = "matched";
export const UNMATCHED_CANDIDATES_TAB = "unmatched_candidates";
export const UNMATCHED_PLACEMENTS_TAB = "unmatched_placements";
